import '@fontsource/roboto/100.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/900.css';

import 'flatpickr/dist/flatpickr.min.css';
import '../node_modules/photoswipe/dist/photoswipe.css';
import '../node_modules/photoswipe-dynamic-caption-plugin/photoswipe-dynamic-caption-plugin.css';
import './../sdist/tailwind.css';

//import Swiper from 'swiper';
import _ from 'lodash';
import $ from 'jquery';

import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';
import PhotoSwipe from 'photoswipe/dist/photoswipe.esm.js';
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin/photoswipe-dynamic-caption-plugin.esm.js';

import morph from '@alpinejs/morph';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import ui from '@alpinejs/ui';

import Countable from 'countable';

import flatpickr from "flatpickr";
import { German } from "flatpickr/dist/l10n/de";

import TomSelect from 'tom-select/dist/esm/tom-select';
import 'tom-select/dist/esm/plugins/remove_button/plugin';
import '../node_modules/tom-select/dist/css/tom-select.min.css';

import './quill_snow.css';
import Quill from 'quill';
import persist from '@alpinejs/persist'

import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import htmx from 'htmx.org';
window.htmx = htmx;


Chart.register(ChartDataLabels);

window.Alpine = Alpine
Alpine.plugin(morph);
Alpine.plugin(collapse);
Alpine.plugin(persist);
Alpine.plugin(focus);
Alpine.plugin(ui);


const TOOLBAR_CONFIG = [
  //[{ header: ['1', '2', false] }],
  ['bold', 'italic', 'underline', 'link'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['clean']
];

const SIMPLE_TOOLBAR_CONFIG = [
  ['bold', 'italic', 'underline', 'link'],
  //[{ list: 'ordered' }, { list: 'bullet' }],
  ['clean']
];


Alpine.store('shortcuts', {
  part_1: true,
  part_2: null,

});


document.addEventListener('alpine:init', () => {

  Alpine.data('toggleExtraField', (initial, condition) => ({
    value: initial,
    isOpen() { return condition(this.value); },
    init() {
      let node = this.$el.querySelector('[x-model="value"]');
      if (node) {
        this.value = node.value || '';
      }
    },
  }));

  Alpine.data('toggleExtraFieldChecked', (initial, condition) => ({
    value: initial,
    isOpen() { return condition(this.value); },
    init() {
      if (Array.isArray(initial)) {
        this.value = [...this.$el.querySelectorAll('[x-model="value"]:checked')].map(node => node.value);
      } else {
        let node = this.$el.querySelector('[x-model="value"]:checked');
        if (node) {
          this.value = node.value;
        }
      }
    },
  }));

  Alpine.data('toggleInnerExtraFieldChecked', (initial, condition) => ({
    innerValue: initial,
    isOpen() { return condition(this.innerValue); },
    init() {
      if (Array.isArray(initial)) {
        this.innerValue = [...this.$el.querySelectorAll('[x-model="innerValue"]:checked')].map(node => node.value);
      } else {
        let node = this.$el.querySelector('[x-model="innerValue"]:checked');
        if (node) {
          this.innerValue = node.value;
        }
      }
    },
  }));

  Alpine.data('Teamsize', (initial) => ({
    value: initial,
    init() {
      let node = this.$el.querySelector('[x-model="value"]');
      if (node) {
        this.value = parseInt(node.value) || 0;
      }
      this.$watch('value', value => {
        this.$dispatch('update-team-size', { size: parseInt(value) });
        console.log('team size changed', value);
      });
    }
  }));

  Alpine.data('toggleExtraFieldSelected', (initial, condition) => ({
    value: initial,
    isOpen() { return condition(this.value); },
    init() {
      if (Array.isArray(initial)) {
        this.value = [...this.$el.querySelectorAll('[x-model="value"] option[selected]')].map(node => node.value);
      } else {
        console.log(this.$el);
        this.value = this.$el.querySelector('[x-model="value"] option[selected]').value;
      }
    },
  }));

  Alpine.data('legalFormVisibility', () => ({
    legalForm: '',
    isNaturalPerson() {
      return this.legalForm === 'self_employed';
    },
    isOrganization() {
      return ['registered_association', 'gbr', 'gmbh_ug', 'other_organization'].includes(this.legalForm);
    },
    updateLegalForm() {
      const checked = document.querySelector("[name$='legal_form']:checked");
      if (checked) {
        this.legalForm = checked.value;
        return;
      }

      const input = document.querySelector("[name$='legal_form']");
      this.legalForm = input ? input.value : '';
    },
    init() {
      this.updateLegalForm();
      document
        .querySelectorAll("[name$='legal_form']")
        .forEach(field => field.addEventListener('change', () => this.updateLegalForm()));
      this.$root.addEventListener('form-page-changed', () => this.updateLegalForm());
    },
  }));


  Alpine.data('multiselect', () => ({
    value: [],
    init() {
      let settings = {};
      new TomSelect(this.$el, settings);
    }
  }));

  Alpine.data('participantCombobox', () => ({
    query: '',
    options: [],
    selected: [],
    init() {
      this.options = Array.from(this.$refs.select.options).map(option => ({
        id: option.value,
        name: option.text,
        disabled: option.disabled,
      }));
      this.selected = this.options.filter(option => (
        this.$refs.select.querySelector(`option[value="${CSS.escape(option.id)}"]`).selected
      ));
      this.$watch('selected', selected => {
        const selectedIds = new Set(selected.map(option => option.id));
        Array.from(this.$refs.select.options).forEach(option => {
          option.selected = selectedIds.has(option.value);
        });
      });
    },
    get filteredOptions() {
      const query = this.query.trim().toLocaleLowerCase();
      if (!query) return this.options;
      return this.options.filter(option => option.name.toLocaleLowerCase().includes(query));
    },
    remove(option) {
      this.selected = this.selected.filter(selected => selected.id !== option.id);
    },
  }));

  Alpine.magic('tooltip', el => message => {
    let instance = tippy(el, { content: message, trigger: 'manual' })

    instance.show()

    setTimeout(() => {
      instance.hide()

      setTimeout(() => instance.destroy(), 150)
    }, 2000)
  })

  // Directive: x-tooltip
  Alpine.directive('tooltip', (el, { expression }) => {
    tippy(el, { content: expression })
  })


  window.CountingField = function (limit, direction, ressource) {
    return {
      limit: limit,
      direction: direction || 'down',
      ressource: ressource || 'all',
      counter: 0,
      count() { return (this.direction === 'down') ? this.limit - this.counter : this.counter },
      reached() { return (this.direction === 'down') ? this.counter === 0 : this.counter >= this.limit },
      init() {
        let node = this.$refs.field;
        if (node) {
          Countable.on(node, counter => { this.counter = counter[this.ressource] })
        }
      }
    }
  }

  const parseDateLimit = value => {
    if (!value) {
      return null;
    }
    return flatpickr.parseDate(value, "Y-m-d") || value;
  };

  const datePickerOptions = (el, overrides = {}) => {
    let options = {
      "locale": German,
      enableTime: false,
      dateFormat: "d.m.Y",
      ...overrides,
    };
    const minDate = el.dataset.flatpickrMinDate || el.getAttribute('min');
    const maxDate = el.dataset.flatpickrMaxDate || el.getAttribute('max');

    if (minDate) {
      options.minDate = parseDateLimit(minDate);
    }
    if (maxDate) {
      options.maxDate = parseDateLimit(maxDate);
    }

    return options;
  };

  let dates = Array.from(document.querySelectorAll(".datepicker_date")).map(
    el => flatpickr(el, datePickerOptions(el))
  );

  let times = flatpickr(".datepicker_time", {
    "locale": German,
    enableTime: true,
    noCalendar: true,
    dateFormat: "H:i",
  });

  function reloadFlatpickr() {
    if (dates) {
      dates.forEach(
        date => date.destroy()
      );
    }

    if (times) {
      times.forEach(
        time => time.destroy()
      );
    }

    dates = Array.from(document.querySelectorAll(".datepicker_date")).map(
      el => flatpickr(el, datePickerOptions(el))
    );
    times = flatpickr(".datepicker_time", {
      "locale": German,
      enableTime: true,
      noCalendar: true,
      dateFormat: "H:i",
    });
  }

  let renderFlatpicker = (el) => {
    let picker = flatpickr(el, {
      "locale": German,
      enableTime: true,
      dateFormat: "d.m.Y H:i",
    })
  }

  let renderDateFlatpicker = (el) => {
    let picker = flatpickr(el, datePickerOptions(el))
  }


  let renderTomSelect = (el) => {
    let settings = {};
    new TomSelect(el, settings);
  }

  let renderCreateSelect = (el) => {
    let settings = {
      create: true,
      createOnBlur: true,
      sortField: 'text'
    };
    new TomSelect(el, settings);
  };

  document.querySelectorAll('.multi-select').forEach(renderTomSelect);
  document.querySelectorAll('.create-select').forEach(renderCreateSelect);

  window.reloadFlatpickr = reloadFlatpickr;
  window.renderTomSelect = renderTomSelect;
  window.renderCreateSelect = renderCreateSelect;
  window.renderFlatpicker = renderFlatpicker;
  window.renderDateFlatpicker = renderDateFlatpicker;


  Alpine.data('loadQuill', (initial) => ({
    init() {
      let quill = new Quill(this.$refs.quill, {
        placeholder: 'Hier Text eingeben ...',
        modules: {
          toolbar: SIMPLE_TOOLBAR_CONFIG
        },
        theme: 'snow'
      })
      quill.root.innerHTML = initial;
      this.$refs.textarea.value = initial;
      this.$refs.textarea.style.display = "none";

      quill.on('text-change', () => {
        this.$refs.textarea._x_model.set(quill.root.innerHTML);
      })
    }
  }));



  window.toggleFeedBackField = function () {
    return {
      value: '',
      na: false,
      rating: null,
      open: false,
      isOpen() { return this.value || this.open; },
      init() {
        let node = this.$el.querySelector('[x-model="value"]');
        if (node) {
          this.value = node.value;
        }

        let rating = this.$el.querySelector('[x-model="rating"]:checked');
        if (rating) {
          this.rating = rating.value;
        }

        let na = this.$el.querySelector('[x-model="na"]:checked');
        if (na) {
          this.na = na.value;
        }
      }
    }
  }

  window.toggleExtraFieldSelected = function (initial, condition) {
    return {
      value: initial,
      isOpen() { return condition(this.value); },
      init() {
        if (Array.isArray(initial)) {
          this.value = [...this.$el.querySelectorAll('[x-model="value"] option[selected]')].map(node => node.value);
        } else {
          this.value = this.$el.querySelector('[x-model="value"] option[selected]').value;
        }
      },
    }
  }


  window.TotalRating = function (initialRating) {
    // {rating: {'fgdfgg': {'rating': x, 'weight': x, 'exclude': true}, ...}}
    return {
      exclude() { return _.filter(_.values(this.rating), o => o.exclude); },
      rated() { return _.filter(_.values(this.rating), o => o.rating !== null && !o.exclude); },
      count() {
        return this.rated().length + this.exclude().length;
      },
      ratedCount() {
        return this.rated().length;
      },
      total() {
        let totalWeights = _.sumBy(this.rated(), o => o.weight);
        let total = _.sumBy(this.rated(), o => o.weight * o.rating) / totalWeights;
        return total;
      },
      update(newRating) {
        // {label: 'fgdfgg', rating: x}
        let ratingValue = parseInt(newRating.rating);

        if (newRating.label in this.rating) {
          if (isNaN(ratingValue)) {
            this.rating[newRating.label].rating = null;
          } else {
            this.rating[newRating.label].rating = ratingValue;
          }
          this.rating[newRating.label].exclude = newRating.exclude || false;
        }
      },
      ...initialRating
    }
  }

  window.ReviewSubmitButton = function () {
    const colorClasses = [
      "bg-gray-700",
      "hover:bg-gray-800",
      "focus:ring-gray-500",
      "bg-green-700",
      "hover:bg-green-800",
      "focus:ring-green-500",
      "bg-amber-500",
      "hover:bg-amber-600",
      "focus:ring-amber-500",
      "bg-red-700",
      "hover:bg-red-800",
      "focus:ring-red-500",
    ];

    return {
      state: "incomplete",
      init() {
        this.$refs.submitButton.classList.remove(...colorClasses);
        this.update();
      },
      update() {
        const fieldNames = [
          ...new Set(
            [...this.$el.querySelectorAll('input[type="radio"][name^="category_"]')].map(
              (field) => field.name,
            ),
          ),
        ];
        const values = fieldNames.map((name) => {
          const selected = this.$el.querySelector(`input[type="radio"][name="${name}"]:checked`);
          return selected ? parseInt(selected.value, 10) : null;
        });

        if (values.length === 0 || values.some((value) => value === null)) {
          this.state = "incomplete";
        } else if (values.includes(0)) {
          this.state = "reject";
        } else if (values.includes(1)) {
          this.state = "rework";
        } else {
          this.state = "accept";
        }
      },
      label() {
        return this.state === "rework" ? "Nachbesserung anfordern" : "Vorprüfung abschließen";
      },
      helpText() {
        if (this.state === "reject") {
          return "Projekt ablehnen";
        }
        if (this.state === "incomplete") {
          return "Noch nicht alle erforderlichen Felder ausgefüllt";
        }
        return this.label();
      },
      buttonClasses() {
        return {
          incomplete: "bg-gray-700 hover:bg-gray-800 focus:ring-gray-500",
          accept: "bg-green-700 hover:bg-green-800 focus:ring-green-500",
          rework: "bg-amber-500 hover:bg-amber-600 focus:ring-amber-500",
          reject: "bg-red-700 hover:bg-red-800 focus:ring-red-500",
        }[this.state];
      },
    };
  };


  window.InlineForms = function (params) {
    return {
      template: null,
      add() {
        let container = document.getElementById(this.container);
        container.insertAdjacentHTML('beforeend', this.template(this.TOTAL_FORMS));
        this.TOTAL_FORMS++;
      },
      loadTemplate(id) {
        let template = document.getElementById(id);
        this.template = (id) => template.innerHTML.replace(/__prefix__/g, id).replace(/__number__/g, id + 1);
      },
    }
  };

  Alpine.store('preview', {
    active: null,
    fullscreen: false,
    app: { id: '', rank: '', name: '' },
    pages: [],
    moderator_app_id: null,
    moderator_updated_at: null,

    setData(pages, app) {
      this.pages = pages;
      this.app = app;
      this.active = '#app';
    },

    activeUrl() {
      const active_page = this.pages.find(page => page.hash === this.active);
      return active_page ? active_page.url : null;
    },

    isModeratorApp(app_id) {
      return this.moderator_app_id === app_id;
    },

    setModeratorData(app_id, updated_at) {
      this.moderator_app_id = app_id;
      this.moderator_updated_at = updated_at;
    },
    isFreshModeratorData() {
      if (!this.moderator_updated_at || !this.moderator_app_id) {
        return false;
      }
      const updated_at = new Date(this.moderator_updated_at);
      const now = new Date();
      const diffSeconds = (now - updated_at) / 1000;
      return diffSeconds < 500; // consider data fresh if updated within the last 500 seconds
    }

    // rating-preview
  });

  const preview = Alpine.store('preview')

  window.PreviewIframe = function () {
    return {
      init() {
        let that = this;
        Alpine.watch(
          'preview.active', () => that.$el.contentWindow.location.replace(preview.activeUrl())
        );
      }
    }
  }


  function CountableField(textarea) {
    var countDisplay = document.getElementById(textarea.id + "_counter");
    var countDown = false;
    var minCount, maxCount;
    var hasQuill = textarea.getAttribute("data-quill") === 'true';
    var is_disabled = textarea.getAttribute("disabled") === 'disabled';

    if (textarea != null && countDisplay != null) {
      minCount = textarea.getAttribute("data-min-count");
      maxCount = textarea.getAttribute("data-max-count");
    }

    if (hasQuill && !is_disabled) {
      // hide textarea
      textarea.style.display = "none";

      // add editor container
      var quillContainer = document.createElement("div");
      quillContainer.setAttribute("id", textarea.id + "_container");
      quillContainer.setAttribute("class", "w-full bg-white mt-0.5");
      textarea.parentNode.insertBefore(quillContainer, textarea.nextSibling);

      // add editor div
      var quillEditor = document.createElement("div");
      quillEditor.setAttribute("id", textarea.id + "_editor");
      quillContainer.appendChild(quillEditor);

      // load data from textarea
      quillEditor.innerHTML = textarea.value;

      var quill = new Quill(quillEditor, {
        placeholder: 'Hier Text eingeben ...',
        modules: {
          toolbar: TOOLBAR_CONFIG
        },
        theme: 'snow'
      });

      quill.on('text-change', function (delta, oldDelta, source) {
        if (source === 'user') {
          Countable.count(quill.root.innerHTML, updateCharatersLeft, { stripTags: true });
          textarea.value = quill.root.innerHTML;
        }
      });

      Countable.count(quill.root.innerHTML, updateCharatersLeft, { stripTags: true });

    } else {
      Countable.on(textarea, updateCharatersLeft);
    }

    function updateCharatersLeft(counter) {
      var count = counter["all"];
      var left = maxCount - count;

      var currentDisplay = countDisplay.getElementsByClassName("text-count-current")[0];
      var maxDisplay = countDisplay.getElementsByClassName("text-count-max")[0];
      var overDisplay = countDisplay.getElementsByClassName("text-count-overmax")[0];

      if (left < 0) {
        currentDisplay.innerHTML = 0;
        overDisplay.style.display = "inline";
        maxDisplay.innerHTML = -left;
      } else {
        currentDisplay.innerHTML = left;
        overDisplay.style.display = "none";
      }
    }
  }

  function SingleLineTextarea(textarea) {
    function normalizeValue(selectionPosition) {
      var originalValue = textarea.value;
      var valueBeforeSelection = originalValue.slice(0, selectionPosition);
      var normalizedValue = originalValue.replace(/\s+/g, ' ').replace(/^ /, '');
      var normalizedBeforeSelection = valueBeforeSelection.replace(/\s+/g, ' ').replace(/^ /, '');
      var maxLength = textarea.maxLength;

      if (maxLength > -1 && normalizedValue.length > maxLength) {
        normalizedValue = normalizedValue.slice(0, maxLength);
        normalizedBeforeSelection = normalizedBeforeSelection.slice(0, maxLength);
      }

      if (textarea.value !== normalizedValue) {
        textarea.value = normalizedValue;
        textarea.setSelectionRange(normalizedBeforeSelection.length, normalizedBeforeSelection.length);
      }
    }

    textarea.addEventListener('input', function () {
      normalizeValue(textarea.selectionStart);
    });

    textarea.addEventListener('paste', function (event) {
      event.preventDefault();

      var pastedText = (event.clipboardData || window.clipboardData).getData('text');
      var selectionStart = textarea.selectionStart;
      var selectionEnd = textarea.selectionEnd;
      textarea.value = textarea.value.slice(0, selectionStart) + pastedText + textarea.value.slice(selectionEnd);
      normalizeValue(selectionStart + pastedText.length);
      textarea.dispatchEvent(new Event('input', { bubbles: true }));
    });

    textarea.addEventListener('blur', function () {
      var originalValue = textarea.value;
      textarea.value = textarea.value.trim();
      if (textarea.value !== originalValue) {
        textarea.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });

    normalizeValue(textarea.selectionStart || textarea.value.length);
  }

  function SimpleQuill(textarea) {
    textarea.style.display = "none";

    // add editor container
    var quillContainer = document.createElement("div");
    quillContainer.setAttribute("id", textarea.id + "_container");
    quillContainer.setAttribute("class", "w-full bg-white mt-0.5");
    textarea.parentNode.insertBefore(quillContainer, textarea.nextSibling);

    // add editor div
    var quillEditor = document.createElement("div");
    quillEditor.setAttribute("id", textarea.id + "_editor");
    quillContainer.appendChild(quillEditor);

    // load data from textarea
    quillEditor.innerHTML = textarea.value;

    var quill = new Quill(quillEditor, {
      placeholder: 'Hier Text eingeben ...',
      modules: {
        toolbar: SIMPLE_TOOLBAR_CONFIG
      },
      theme: 'snow'
    });

    quill.on('text-change', function (delta, oldDelta, source) {
      if (source === 'user') {
        textarea.value = quill.root.innerHTML;
      }
    });
  }


  document.addEventListener('DOMContentLoaded', function (e) {
    ;
    [].forEach.call(document.querySelectorAll('[data-normalize-whitespace="single-line"]'), SingleLineTextarea);
    [].forEach.call(document.querySelectorAll('[data-count]'), CountableField);
    [].forEach.call(document.querySelectorAll('[data-simple-quill]'), SimpleQuill);
  })


  var barOptions_stacked = {
    tooltips: {
      enabled: false
    },
    hover: {
      animationDuration: 0
    },
    indexAxis: 'y',
    scales: {
      x: {
        ticks: {
          beginAtZero: true,
          fontFamily: "'Open Sans Bold', sans-serif",
          fontSize: 11,
        },
        scaleLabel: {
          display: true
        },
        gridLines: {},
        stacked: true
      },
      y: {
        gridLines: {
          display: false,
          color: "#fff",
          zeroLineColor: "#fff",
          zeroLineWidth: 0
        },
        ticks: {
          fontFamily: "'Open Sans Bold', sans-serif",
          fontSize: 12,
        },
        stacked: true
      }
    },
    legend: {
      display: false
    },
    pointLabelFontFamily: "Quadon Extra Bold",
    scaleFontFamily: "Quadon Extra Bold",
    plugins: {
      datalabels: {
        font: {
          weight: 'bold'
        },
        display: function(context) {
          // skip first dataset if value is max in all datasets (to avoid double label)
          if (context.datasetIndex === 0) {
            // get max at same index in all datasets
            let max = context.chart.data.datasets.map(function(e) {
              return e.data[context.dataIndex];
            }).reduce(function(a, b) {
              return Math.max(a, b);
            });
            return context.dataset.data[context.dataIndex] !== max;
          } else {
            return true;
          }
        },
        formatter: function(value, context) {
          // show total for last dataset
          if (context.datasetIndex === context.chart.data.datasets.length - 1) {
            let total = context.chart.data.datasets.map(function(e) {
               return e.data[context.dataIndex];
            }
            ).reduce(function(a, b) {
              return a + b;
            }
            );
            return total
          } else {
            return value;
          }
        },
      },
    }
  };

  Alpine.data("chart", (datasource) => ({
    chart: null,
    labels: null,
    datasets: null,
    init() {
      let data = JSON.parse(document.getElementById(datasource).textContent);
      this.labels = data.labels;
      this.datasets = data.datasets;
      this.chart = new Chart(this.$el, {
        type: "bar",
        plugins: [ChartDataLabels],
        data: {
          labels: this.labels,
          datasets: this.datasets
        },
        options: barOptions_stacked
      });
    }
  }));

});


if (document.getElementsByClassName('gallery-main').length) {
  const gallerylightbox = new PhotoSwipeLightbox({
    gallerySelector: '.gallery-main',
    childSelector: '.gallery-item',
    pswpModule: PhotoSwipe,
    showHideAnimationType: 'fade',

    // Optional padding for images,
    // note that this is an option of PhotoSwipe, not a plugin
    paddingFn: (viewportSize) => {
      return {
        top: 30, bottom: 30, left: 70, right: 70
      }
    },
  });

  const gallerycaptionPlugin = new PhotoSwipeDynamicCaption(gallerylightbox, {
    // Plugins options, for example:
    type: 'auto',
    captionContent: '.pswp-caption-content',
  });

  // make sure you init photoswipe core after plugins are added
  gallerylightbox.init();
}

const SAXONY_DISTRICT_MAP_STYLES = [
  { featureType: 'all', elementType: 'geometry', stylers: [{ saturation: -100 }, { lightness: 18 }] },
  { featureType: 'all', elementType: 'labels.text.fill', stylers: [{ color: '#5f6368' }] },
  { featureType: 'all', elementType: 'labels.text.stroke', stylers: [{ color: '#f3f4f6' }, { weight: 2 }] },
  { featureType: 'poi', elementType: 'all', stylers: [{ visibility: 'off' }] },
  { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#d1d5db' }] },
  { featureType: 'road', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  { featureType: 'transit', elementType: 'all', stylers: [{ visibility: 'off' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#cbd5e1' }] },
  { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: '#e5e7eb' }] },
];

function geoJsonBounds(geojson) {
  const bounds = new google.maps.LatLngBounds();
  const extendCoordinates = coordinates => {
    if (!Array.isArray(coordinates)) return;
    if (typeof coordinates[0] === 'number' && typeof coordinates[1] === 'number') {
      bounds.extend({ lat: coordinates[1], lng: coordinates[0] });
      return;
    }
    coordinates.forEach(extendCoordinates);
  };

  (geojson.features || []).forEach(feature => {
    if (feature.geometry) extendCoordinates(feature.geometry.coordinates);
  });
  return bounds;
}

function districtLegendItems(geojson) {
  return (geojson.features || [])
    .map(feature => feature.properties || {})
    .map(properties => ({
      label: properties.label || properties.GEN || '',
      color: properties.map_color || '#94a3b8',
    }))
    .filter(district => district.label)
    .sort((a, b) => a.label.localeCompare(b.label, 'de'));
}

async function drawSaxonyDistricts(map, districtsUrl) {
  const response = await fetch(districtsUrl);
  if (!response.ok) {
    console.warn('Landkreisgrenzen konnten nicht geladen werden.');
    return { districts: [], bounds: null };
  }

  const geojson = await response.json();
  const bounds = geoJsonBounds(geojson);
  map.data.addGeoJson(geojson);
  map.data.setStyle(feature => ({
    fillColor: feature.getProperty('map_color') || '#94a3b8',
    fillOpacity: 0.46,
    strokeColor: '#ffffff',
    strokeOpacity: 0.95,
    strokeWeight: 1.4,
    clickable: false,
    zIndex: 1,
  }));

  return {
    districts: districtLegendItems(geojson),
    bounds,
  };
}

function fitMap(map, districtBounds, markers) {
  const bounds = new google.maps.LatLngBounds();
  if (districtBounds && !districtBounds.isEmpty()) {
    bounds.union(districtBounds);
  }
  markers.forEach(marker => bounds.extend({ lat: marker.lat, lng: marker.lng }));

  if (!bounds.isEmpty()) {
    map.fitBounds(bounds, 32);
  }
}

function createCircleMarker(map, markerData, options) {
  const marker = new google.maps.Marker({
    position: { lat: markerData.lat, lng: markerData.lng },
    map,
    title: markerData.title,
    icon: createCircleMarkerIcon(markerData, options),
    zIndex: options.zIndex(markerData),
  });
  return marker;
}

function createCircleMarkerIcon(markerData, options) {
  return {
    path: google.maps.SymbolPath.CIRCLE,
    scale: options.scale(markerData),
    fillColor: options.fillColor ? options.fillColor(markerData) : markerData.marker_color,
    fillOpacity: options.fillOpacity(markerData),
    strokeWeight: options.strokeWeight ? options.strokeWeight(markerData) : 2,
    strokeColor: options.strokeColor ? options.strokeColor(markerData) : '#ffffff',
  };
}

window.juryMapApp = function juryMapApp(config = {}) {
  return {
    markers: config.markers || [],
    selected: null,
    legendOpen: true,
    districts: [],
    _gmMarkers: {},
    _map: null,
    _districtBounds: null,

    async init() {
      const { Map } = await google.maps.importLibrary('maps');
      await google.maps.importLibrary('marker');

      this._map = new Map(document.getElementById(config.mapElementId || 'jury-map'), {
        center: { lat: 51.05, lng: 13.45 },
        zoom: 8,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        styles: SAXONY_DISTRICT_MAP_STYLES,
      });

      const districtLayer = await drawSaxonyDistricts(this._map, config.districtsUrl);
      this.districts = districtLayer.districts;
      this._districtBounds = districtLayer.bounds;
      this.renderMarkers();
      this.fitMap();
      this.startPolling();
    },

    renderMarkers() {
      Object.values(this._gmMarkers).forEach(marker => marker.setMap(null));
      this._gmMarkers = {};

      this.markers.forEach(markerData => {
        const marker = createCircleMarker(this._map, markerData, {
          scale: m => m.is_meeting_project ? 8 : 6,
          fillOpacity: m => m.is_meeting_project ? 0.95 : 0.75,
          zIndex: m => m.is_meeting_project ? 20 : 10,
        });
        marker.addListener('click', () => { this.selected = markerData; });
        this._gmMarkers[markerData.id] = marker;
      });
    },

    fitMap() {
      fitMap(this._map, this._districtBounds, this.markers);
    },

    startPolling() {
      if (!config.mapDataUrl) return;
      window.setInterval(() => this.refreshMarkers(), 5000);
    },

    async refreshMarkers() {
      const response = await fetch(config.mapDataUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!response.ok) return;

      const data = await response.json();
      this.markers = data.markers || [];
      if (this.selected) {
        this.selected = this.markers.find(marker => marker.id === this.selected.id) || null;
      }
      this.renderMarkers();
    },

    panTo(markerData) {
      this.selected = markerData;
      this._map.panTo({ lat: markerData.lat, lng: markerData.lng });
      if (this._map.getZoom() < 11) this._map.setZoom(11);
    },

    selectById(id) {
      const markerData = this.markers.find(marker => marker.id === id);
      if (markerData) this.panTo(markerData);
    },
  };
};

window.rankingMapApp = function rankingMapApp(config = {}) {
  const activeMarkerColor = config.activeMarkerColor || '#1e3a8a';

  return {
    markers: config.markers || [],
    selected: null,
    legendOpen: true,
    districts: [],
    _gmMarkers: {},
    _map: null,
    _districtBounds: null,
    _activeMarkerId: null,

    async init() {
      const { Map } = await google.maps.importLibrary('maps');
      await google.maps.importLibrary('marker');

      this._map = new Map(document.getElementById(config.mapElementId || 'ranking-map'), {
        center: { lat: 51.05, lng: 13.45 },
        zoom: 8,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        styles: SAXONY_DISTRICT_MAP_STYLES,
      });

      const districtLayer = await drawSaxonyDistricts(this._map, config.districtsUrl);
      this.districts = districtLayer.districts;
      this._districtBounds = districtLayer.bounds;
      this.renderMarkers();
      this.fitMap();
      this.startActiveMarkerWatcher();
    },

    renderMarkers() {
      Object.values(this._gmMarkers).forEach(marker => marker.setMap(null));
      this._gmMarkers = {};

      this.markers.forEach(markerData => {
        const marker = createCircleMarker(this._map, markerData, {
          scale: m => this.isActiveMarker(m) ? 10 : (m.is_context ? 6 : 8),
          fillColor: m => this.isActiveMarker(m) ? activeMarkerColor : m.marker_color,
          fillOpacity: m => m.is_context ? 0.7 : 0.95,
          strokeWeight: m => this.isActiveMarker(m) ? 3 : 2,
          zIndex: m => this.isActiveMarker(m) ? 40 : (m.is_context ? 10 : 20),
        });
        marker.addListener('click', () => { this.selected = markerData; });
        this._gmMarkers[markerData.id] = marker;
      });
    },

    fitMap() {
      fitMap(this._map, this._districtBounds, this.markers);
    },

    isActiveMarker(markerData) {
      return !markerData.is_context && markerData.id === this._activeMarkerId;
    },

    getParentActiveMarkerId() {
      try {
        const parentAlpine = window.parent && window.parent.Alpine;
        const previewStore = parentAlpine && parentAlpine.store('preview');
        return previewStore && previewStore.app ? Number(previewStore.app.id) || null : null;
      } catch (error) {
        return null;
      }
    },

    startActiveMarkerWatcher() {
      this.updateActiveMarker();
      window.setInterval(() => this.updateActiveMarker(), 300);
    },

    updateActiveMarker() {
      const activeMarkerId = this.getParentActiveMarkerId();
      if (activeMarkerId === this._activeMarkerId) return;

      this._activeMarkerId = activeMarkerId;
      Object.entries(this._gmMarkers).forEach(([id, marker]) => {
        const markerData = this.markers.find(item => item.id === Number(id));
        if (!markerData) return;

        const options = {
          scale: m => this.isActiveMarker(m) ? 10 : (m.is_context ? 6 : 8),
          fillColor: m => this.isActiveMarker(m) ? activeMarkerColor : m.marker_color,
          fillOpacity: m => m.is_context ? 0.7 : 0.95,
          strokeWeight: m => this.isActiveMarker(m) ? 3 : 2,
          zIndex: m => this.isActiveMarker(m) ? 40 : (m.is_context ? 10 : 20),
        };
        marker.setIcon(createCircleMarkerIcon(markerData, options));
        marker.setZIndex(options.zIndex(markerData));
      });
    },
  };
};

Alpine.start();
